export default __webpack_public_path__ + "static/media/loadingcan.489f0ad0.gif";